import { Link } from 'react-router-dom';
import { featuredVideos, videos } from '@/mocks/videos';

export default function FeaturedVideos() {
  const hotVideos = videos.filter((v) => v.isHot);

  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            热门推荐
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            精选当下最受欢迎的影视内容，一键播放畅享精彩
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {featuredVideos.map((video) => (
            <Link
              key={video.id}
              to={`/category/${video.category}`}
              className="group relative rounded-xl overflow-hidden bg-background-100 hover:ring-2 hover:ring-primary-300 transition-all duration-300 cursor-pointer block no-underline"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={`${video.title} - ${video.categoryName}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/70 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md text-xs font-semibold bg-accent-500 text-secondary-950 whitespace-nowrap">
                    {video.badge}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-base md:text-lg font-bold text-background-50 font-heading line-clamp-1">
                    {video.title}
                  </h3>
                  <p className="text-sm text-background-50/70 mt-1 line-clamp-2">
                    {video.description}
                  </p>
                  <div className="flex items-center gap-3 mt-2">
                    <span className="flex items-center gap-1 text-xs text-accent-300">
                      <i className="ri-star-fill text-sm"></i>
                      {video.rating}
                    </span>
                    <span className="text-xs text-background-50/50">{video.categoryName}</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {hotVideos.map((video) => (
            <Link
              key={video.id}
              to={`/category/${video.category}`}
              className="group relative rounded-lg overflow-hidden bg-background-100 hover:ring-2 hover:ring-secondary-300 transition-all duration-300 cursor-pointer block no-underline"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={`${video.title} - ${video.categoryName}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/60 via-transparent to-transparent"></div>
                <div className="absolute top-2 right-2">
                  <span className="px-1.5 py-0.5 rounded text-[10px] font-semibold bg-primary-500 text-background-50 whitespace-nowrap">
                    {video.rating}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-2.5">
                  <h3 className="text-xs md:text-sm font-medium text-background-50 line-clamp-1">
                    {video.title}
                  </h3>
                  <span className="text-[10px] text-background-50/50 mt-0.5 block">{video.views} 次播放</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/dianshiju"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full text-sm font-medium text-primary-600 border border-primary-300 hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看更多热门内容
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}